"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailIsDefault = void 0;
const emailIsDefault = (email) => (email.match(/anon\.dayswaps\.com/)?.length ?? 0) > 0;
exports.emailIsDefault = emailIsDefault;
